export const REVIEWS_LIMIT = 6;
export const FAQ_LIMIT = 4;
export const SIMILAR_RENTALS_LIMIT = 4;
export const ROUTE_PARAMS = ['location', 'slug'];

/**
 * States where RVs cannot be set up / delivered at state parks. When a chosen
 * delivery location falls in one of these states we surface a restriction
 * warning. Both the abbreviation and the full name are included because address
 * sources vary in how they report the state value.
 */
export const STATE_PARK_WARNING_STATES = new Set(['CA', 'California']);
